import { all, call, put, takeLatest } from 'redux-saga/effects'

import { sepaBankTranfer } from 'api/apiDataHelpers'
import {
    getRequest,
    getRequestV2,
    getRequestV3,
    getRequestWithBlob,
    getRequestWithBlobV2,
    postRequest,
    postRequestV3,
    putRequest,
    putRequestV2,
    putRequestV3,
} from 'api/apiUtils'
import TradingDeskActionTypesV2 from 'redux/tradingDeskV2/tradingDeskV2-types'

import { fetchNotificationAlert as fetchNotificationAlertAction } from '../alert/alert-actions'
import CardsActionTypes from '../cards/cards-types'
import DigitalAssetkActionTypes from '../digitalAssets/digitalAssets-types'
import LedgerActionTypes from '../ledger/ledger-types'
import SettingsActionTypes from '../settings/settings-types'
import SignalRTypes from '../signalR/signalR-types'
import UserActionTypes from '../user/user-types'

import {
    failureCancelTransaction,
    failureCompleteTransaction,
    failureFakeDeposit,
    failureFilteringTransactions,
    failurePutTransactionNote,
    finishPutTransactionNote,
    startTransactions,
    successAlertTransaction,
    successApproveTransaction,
    successCancelTransaction,
    successCompleteTransaction,
    successDownloadPdfTransaction,
    successFakeDeposit,
    successFilteringTransactions,
    successGetCounts,
    successGetCsvStatement,
    successGetFiles,
    successGetPdfStatement,
    successGetStatuses,
    successGetTxtStatement,
    successGetXmlStatement,
    successPayTransaction,
    successPutTransactionNote,
    successTransactions,
} from './transactions-actions'
import TransactionsActionTypes from './transactions-types'

function* startFilteringTransactions({ payload: values }) {
    try {
        const { from, to, status, type, accountIds = [], page, pageSize } = { ...values }

        const dataToPost = {
            from,
            to,
            status,
            type,
            accountIds,
            page,
            pageSize,
        }

        const { data } = yield postRequestV3('/user/assets/transfers', dataToPost)

        yield put(successFilteringTransactions(data))
    } catch (err) {
        yield put(failureFilteringTransactions({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log('Error startFilteringTransactions', err?.response?.data)
        }
    }
}

export function* onStartFilteringTransactions() {
    yield takeLatest(TransactionsActionTypes.START_FILTERING_TRANSACTIONS, startFilteringTransactions)
}

function* startGetStatuses() {
    try {
        const { data: statuses } = yield getRequestV3('/user/assets/transfers/statuses')

        yield put(successGetStatuses(statuses))
    } catch (error) {
        yield
    }
}

export function* onStartGetStatuses() {
    yield takeLatest(TransactionsActionTypes.START_GET_STATUSES, startGetStatuses)
}

function* startFetchTransaction() {
    try {
        yield put(startTransactions())
        const { data } = yield postRequestV3('/user/assets/transfers', { page: 1, pageSize: 5 })
        const { data: counts } = yield getRequestV3('/user/assets/transfers/counts')

        yield put(successTransactions(data))
        yield put(successGetCounts(counts))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log('err fetching transactions', err)
        }
    }
}

export function* onStartFetchTransaction() {
    yield takeLatest(
        [
            SettingsActionTypes.SUCCESS_SERVICE_PLAN,
            UserActionTypes.SIGN_IN_SUCCESS,
            CardsActionTypes.SUCCESS_CARD_ORDER,
            CardsActionTypes.SUCCESS_CARD_TOP_UP,
            LedgerActionTypes.SUCCESS_EXCHANGE_All_ASSETS,
            CardsActionTypes.SUCCESS_CARD_WITHDRAW,
            LedgerActionTypes.SUCCESS_BANK_ACCOUNT_ORDER,
            LedgerActionTypes.SUCCESS_TOP_UP_WITH_BANK_TRANSFER,
            LedgerActionTypes.SUCCESS_SECURE_3D_CARD,
            LedgerActionTypes.SUCCESS_TRANSFER,
            LedgerActionTypes.FINISH_PAY_NOW,
            TransactionsActionTypes.FINISH_CANCEL_TRANSACTION,
            TransactionsActionTypes.FINISH_APPROVE_TRANSACTION,
            TransactionsActionTypes.FINISH_COMPLETE_TRANSACTION,
            TransactionsActionTypes.FINISH_PAY_TRANSACTION,
            LedgerActionTypes.SUCCESS_TRANSFER_TO_BANK,
            LedgerActionTypes.SUCCESS_ORDER_CURRENCY,
            TradingDeskActionTypesV2.SUCCESS_ACCOUNT_DEPOSIT,
            TradingDeskActionTypesV2.SUCCESS_ACCOUNT_WITHDRAW,
            TradingDeskActionTypesV2.SUCCESS_EXCHANGE,
            DigitalAssetkActionTypes.SUCCESS_SEND_DIGITAL_ASSETS_AMOUNT,
            DigitalAssetkActionTypes.SUCCESS_BUY_USDC_COIN,
            DigitalAssetkActionTypes.SUCCESS_TRANSFER_USDC_COIN,
            SignalRTypes.START_FETCH_TRANSACTIONS,
        ],
        startFetchTransaction
    )
}

function* startAlertTransaction({ payload: { no } }) {
    try {
        const { data } = yield getRequestV2(`/user/assets/transfers/${no}`)

        yield put(successAlertTransaction(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartAlertTransaction() {
    yield takeLatest(TransactionsActionTypes.START_ALERT_TRANSACTION, startAlertTransaction)
}

function* startPutTransactionNote({ payload: { no, note } }) {
    try {
        yield putRequest(`/user/assets/transfers/${no}/note`, { note })
        yield put(successPutTransactionNote())
        yield put(finishPutTransactionNote())
    } catch (err) {
        yield put(failurePutTransactionNote({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartPutTransactionNote() {
    yield takeLatest(TransactionsActionTypes.START_PUT_TRANSACTION_NOTE, startPutTransactionNote)
}

function* startCancelTransaction({ payload: { no, cancelTransactionType } }) {
    const urls = {
        transfers: `/user/assets/transfers/${no}/cancel`,
        exchanges: `/user/tradingDesk/exchanges/${no}/cancel`,
    }

    try {
        yield !!urls[cancelTransactionType] && putRequestV2(urls[cancelTransactionType])
        yield put(successCancelTransaction())
    } catch (err) {
        yield put(failureCancelTransaction({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartCancelTransaction() {
    yield takeLatest(TransactionsActionTypes.START_CANCEL_TRANSACTION, startCancelTransaction)
}

function* startCompleteTransaction({ payload: { no } }) {
    try {
        yield putRequest(`/user/assets/currencies/deposits/${no}/complete`)
        yield put(successCompleteTransaction())
        yield put(fetchNotificationAlertAction())
    } catch (err) {
        yield put(failureCompleteTransaction({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartCompleteTransaction() {
    yield takeLatest(TransactionsActionTypes.START_COMPLETE_TRANSACTION, startCompleteTransaction)
}

function* startApproveTransaction({ payload: { no, verificationCode } }) {
    try {
        yield putRequestV3(`/user/assets/transfers/${no}/approve`, { verificationCode })
        yield put(successApproveTransaction())
        yield put(fetchNotificationAlertAction())
    } catch (err) {
        yield put(failureCompleteTransaction({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartApproveTransaction() {
    yield takeLatest(TransactionsActionTypes.START_APPROVE_TRANSACTION, startApproveTransaction)
}

function* startFakeDeposit({ payload: { type, fromAsset, amount } }) {
    try {
        const parsedData = yield sepaBankTranfer({ type, fromAsset, amount })

        yield postRequest('/user/assets/currencies/deposits/bank', parsedData)
        yield startFetchTransaction()
        yield put(successFakeDeposit())
    } catch (err) {
        yield put(failureFakeDeposit({ errorMessage: err?.response?.data?.errors }))
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartFakeDeposit() {
    yield takeLatest(TransactionsActionTypes.START_FAKE_DEPOSIT, startFakeDeposit)
}

function* fetchPayTransaction({ payload: { no } }) {
    try {
        const { data } = yield getRequestV2(`/user/assets/transfers/${no}`)

        yield put(successPayTransaction(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onFetchPayTransaction() {
    yield takeLatest(TransactionsActionTypes.FETCH_PAY_TRANSACTION, fetchPayTransaction)
}

function* startDownloadPdfTransaction({ payload: { no } }) {
    try {
        const { data } = yield getRequestWithBlobV2(`/user/assets/transfers/${no}/pdf`)

        yield put(successDownloadPdfTransaction(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartDownloadPdfTransaction() {
    yield takeLatest(TransactionsActionTypes.START_DOWNLOAD_PDF_TRANSACTION, startDownloadPdfTransaction)
}

function* startGetPdfStatement({ payload: { id, from, to } }) {
    try {
        const fromToQuery = `?From=${from}&To=${to}`
        const { data } = yield getRequestWithBlobV2(`/user/assets/${id}/statements/pdf${fromToQuery}`)

        yield put(successGetPdfStatement(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetPdfStatement() {
    yield takeLatest(TransactionsActionTypes.START_GET_PDF_STATEMENT, startGetPdfStatement)
}

function* startGetTxtStatement({ payload: { id, from, to } }) {
    try {
        const fromToQuery = `?From=${from}&To=${to}`
        const { data } = yield getRequest(`/user/assets/${id}/statements/txt${fromToQuery}`)

        yield put(successGetTxtStatement(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetTxtStatement() {
    yield takeLatest(TransactionsActionTypes.START_GET_TXT_STATEMENT, startGetTxtStatement)
}

function* startGetXmlStatement({ payload: { id, from, to } }) {
    try {
        const fromToQuery = `?From=${from}&To=${to}`
        const { data } = yield getRequest(`/user/assets/${id}/statements/xml${fromToQuery}`)

        yield put(successGetXmlStatement(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetXmlStatement() {
    yield takeLatest(TransactionsActionTypes.START_GET_XML_STATEMENT, startGetXmlStatement)
}

function* startGetCsvStatement({ payload: { id, from, to } }) {
    try {
        const fromToQuery = `?From=${from}&To=${to}`
        const { data } = yield getRequestWithBlob(`/user/assets/${id}/statements/csv${fromToQuery}`)

        yield put(successGetCsvStatement(data))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetCsvStatement() {
    yield takeLatest(TransactionsActionTypes.START_GET_CSV_STATEMENT, startGetCsvStatement)
}

function* startGetFiles({ payload: { files } }) {
    const retrievedFiles = []

    try {
        for (const { identifier, name } of files) {
            const { data } = yield getRequestWithBlob(`/files/${identifier}`)

            retrievedFiles.push({ data, name })
        }
        yield put(successGetFiles(retrievedFiles))
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetFiles() {
    yield takeLatest(TransactionsActionTypes.START_GET_FILES, startGetFiles)
}

function* pushAccountPage() {
    yield startFetchTransaction()
}

export function* onPushAccountPage() {
    yield takeLatest(UserActionTypes.PUSH_ACCOUNT_PAGE, pushAccountPage)
}

export function* transactionsSagas() {
    yield all([
        call(onStartFilteringTransactions),
        call(onStartAlertTransaction),
        call(onFetchPayTransaction),
        call(onPushAccountPage),
        call(onStartPutTransactionNote),
        call(onStartCancelTransaction),
        call(onStartCompleteTransaction),
        call(onStartFakeDeposit),
        call(onStartApproveTransaction),
        call(onStartGetTxtStatement),
        call(onStartGetPdfStatement),
        call(onStartGetXmlStatement),
        call(onStartGetCsvStatement),
        call(onStartGetFiles),
        call(onStartDownloadPdfTransaction),
        call(onStartGetStatuses),
        call(onStartFetchTransaction),
    ])
}
